import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';
import { trigger, style, animate, transition } from '@angular/animations';


@Component({
  standalone: false,
  selector: 'app-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.scss'],
  animations: [
  trigger('fadeS', [
    transition('void => *', [
      style({ opacity: 0 }),
      animate(1300, style({ opacity: 1 }))
    ])
  ])
]
})
export class SecurityComponent implements OnInit {

  constructor(private r: Router, private commonService: CommonsService) { }

  ngOnInit() {
    this.commonService.firstChargePage('Security', 'Apartado de seguridad', 'Security');
    this.commonService.eventsAnalitics('visit screen', 'content', 'Security');
  }

  goToUrl = (url) => {
    this.commonService.eventsAnalitics('click', 'content', this.capitalize(url));
    this.r.navigateByUrl(url);
  }

  capitalize = (word: string) => {
    return word[0].toUpperCase() + word.slice(1);
  }
}
